"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

var toMiliseconds_1 = require("./toMiliseconds");

function currentTimeUnix() {
  return toMiliseconds_1.toMilliseconds(moment_1.default().unix());
}

exports.currentTimeUnix = currentTimeUnix;